import React, { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
import TitleLayout from '../../kosherTeudot/generic/TitleLayout'
import TitleRow from '../../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../../kosherTeudot/generic/TitleRowItem'
import { IProblemLineNew, IProblemWithDetailsNew } from '../../../../../modules/API/TeudotProblems/models/problems'
import CalendatDay from '../../../../../generic/icons/IconLib/CalendarIcon'
import InvoiceIcon from '../../../../../generic/icons/IconLib/InvoiceIcon'
import UserIcon from '../../../../../generic/icons/IconLib/UserIcon'
import EditIcon from '../../../../../generic/icons/IconLib/PencilIcon'
import DollarIcon from '../../../../../generic/icons/IconLib/DollarIcon'
import AppleIcon from '../../../../../generic/icons/IconLib/AppleIcon'
import DeleteIcon from '../../../../../generic/icons/IconLib/TrashIcon'
import TimeIcon from '../../../../../generic/icons/IconLib/ClockIcon'
import ErrorIcon from '../../../../../generic/icons/IconLib/AlertCircleIcon'
import PrintIcon from '../../../../../generic/icons/IconLib/PrintIcon'
import ProblemDetailsItem from './ProblemDetailsItem'
import ProductImage from '../../queries/TeudotDetails/Components/ProductImage'
import { getStatusText, getStatusColor, useProblemHelpers, problemStatuses, statusListForSelect } from '../hooks/useProblemHelpers'
import { convertToDate } from '../../../../../modules/convertDateString'
import CircleActiveFilterBtn from '../../../../../generic/particles/CircleActiveFilterBtn'
import { SwipeableListItem } from '../../../../../generic/swipe/SwipeableListAdapter'
import SwipeContent from '../../knisot/Components/SwipeContent'
import StatusBadge from './StatusBadge'
import { format } from 'date-fns'
import { IApproveProblemBulkData, IApproveProblemData } from '../../../../../modules/API/TeudotProblems/models/requests'
import { DropdownSelect } from './DropdownSelect'
import DeliveryProfitBadge from './DeliveryProfitBadge'
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton'
import PaperclipIcon from '../../../../../generic/icons/IconLib/PaperclipIcon'

interface Props extends IProblemWithDetailsNew {
  handleSelectProblem?: (problem: IProblemWithDetailsNew) => void
  handleDeleteProblem?: (recId: number) => void
  handleApproveProblem?: (topRecID: number, data: IApproveProblemData) => void
  isAllowToApprove: boolean
  isOfficeUser: boolean
  handleBulkApproveProblems?: (data: IApproveProblemBulkData) => void
  handleOpenDriverStatusModal?: (line: IProblemLineNew, parent: IProblemWithDetailsNew) => void
  handleOpenProblemImages?: (recID: number) => void
}


const ProblemWithDetailsItem = (props: Props) => {
  const {
    RecID,
    GeneralProductID,
    FullDescription,
    Delivery_Date,
    Delivery_Num,
    Delivery_Sub,
    Status,
    Remark,
    ProblemLines,
    DeliveryProfitPercentage,
    handleSelectProblem,
    handleDeleteProblem,
    handleApproveProblem,
    Seller_Desc,
    Customer_Name,
    CreateTime,
    isAllowToApprove,
    handleBulkApproveProblems,
    DeliveryProfit,
    DeliveryProfitDelta,
    isOfficeUser,
    Meher,
    handleOpenDriverStatusModal,
    HasPhotoOrComment,
    handleOpenProblemImages,
  } = props

  const openDriverStatusForLine = useCallback(
    (line: IProblemLineNew) => handleOpenDriverStatusModal?.(line, props),
    [handleOpenDriverStatusModal, props]
  )
  const [isOpen, setIsOpen] = useState(false)
  // Клик по кнопке не должен раскрывать карточку.
  const handleImagesClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    handleOpenProblemImages?.(RecID)
  }
  const [isShowDelete, setIsShowDelete] = useState(false)
  const handleClick = (e?: React.MouseEvent | React.KeyboardEvent) => {
    if (e) e.stopPropagation()
    setIsOpen(!isOpen)
  }

  const handleEditButtonClick = () => {
    if (handleSelectProblem) {
      handleSelectProblem(props)
    }
  }

  const handleSwipeDelete = () => {
    setIsShowDelete(!isShowDelete)
  }

  const handleDeleteItem = () => {
    if (handleDeleteProblem) {
      handleDeleteProblem(RecID)
    }
  }

  const handleSwipeEdit = () => {
    if (handleSelectProblem) {
      handleSelectProblem(props)
    }
  }

  const handleSwipeEnd = () => {
    setIsOpen(isOpen ? true : false)
  }
  const handleClickApproveProblem = (data: IApproveProblemData) => {
    if (handleApproveProblem) {
      handleApproveProblem(RecID, data)
    }
  }

  const handleClickBulkApproveProblems = (status: number) => {
    if (handleBulkApproveProblems) {
      handleBulkApproveProblems({
        Status: status,
        RecID: RecID,
      })
    }
  }
  const {
    hasProblems,
    statusCounts,
    displayColor,
    displayStatusText,
    printPdf,
  } = useProblemHelpers(ProblemLines)
  
  const isExistOpenProblem = useMemo(() => {
    return ProblemLines.some(problem => problem.Status === 0 || problem.Status === 3)
  }, [ProblemLines])
  const isExistSolvedProblem = useMemo(() => {
    return ProblemLines.some(problem => problem.Status !== 0)
  }, [ProblemLines])
  const isExistOpenDriverProblem = useMemo(() => {
    return ProblemLines.some(problem =>
       problem.ProblemType === 3 && problem.DriverStatus === 0)
  }, [ProblemLines])
  // Use convertToDate to format Delivery_Date string
  const formattedDeliveryDate = Delivery_Date ? convertToDate(Delivery_Date) : ''
  const formattedCreateTimeFromISO = {
    time: format(new Date(CreateTime), 'HH:mm'),
    date: format(new Date(CreateTime), 'dd/MM/yyyy')
  }
 
  const handleStatusChange = (user: {id: number, desc: string}) => {
    handleClickBulkApproveProblems(user.id)
  }
  return (

    <MainWrapper 
    tabIndex={0} 
    aria-label={`פרטי פניה #${RecID}`}
    $isOpen={isOpen}
    >
      <TitleLayout 
        borderColor={getStatusColor(Status)}
        isDraggable
      >
         {
            isAllowToApprove && 
            isExistOpenProblem && 
            isOfficeUser && 
            !isExistOpenDriverProblem && (
              <SelectorWrapper>
                <DropdownSelect<{id: number, desc: string}, 'id', 'desc'>
                  items={statusListForSelect}
                  valueKey="id"          // defaultValue будет сравниваться по user.id
                  labelKey="desc"        // в списке и триггере показываем user.name
                  defaultValue={Status}       // сразу выберется Bob
                  onChange={handleStatusChange}
                  placeholder="בחר סטטוס"
                  isTop={true}
                />

                </SelectorWrapper>
            )
          }
        <SwipeableListItem
          onSwipeEnd={handleSwipeEnd}
          onSwipeStart={handleSwipeEnd}
          swipeLeft={
            !isExistSolvedProblem ? 
            {
              content: <SwipeContent text={'מחק'} isPrimal position='right' />,
              action: handleSwipeDelete
            } : undefined
        }
          swipeRight={{
            content: <SwipeContent text={
              Status !== 0 ? "עיון" :
              'עדכון'
            } position='left' />,
            action: handleSwipeEdit
          }} 
          
          blockSwipe={!handleSelectProblem}
          threshold={0.3}
        >
          <MainContentWrapper>
            <TitleWrapper onClick={handleClick}>
           
              <SideWrapper>
                <ProductImage 
                  id={GeneralProductID}
                />
              </SideWrapper>
              <TitleRow>
                <TimeWrapper>
                  <TitleRowItem 
                    name={`${formattedCreateTimeFromISO.time}`}
                    icon={<TimeIcon />}
                  />
                  <IconElement
                    onClick={() => printPdf(Delivery_Num, Delivery_Sub)}
                  >
                    <PrintIcon />
                  </IconElement>
                </TimeWrapper>

                <TitleRowItem 
                  name={`פניה #${RecID} - ${formattedCreateTimeFromISO.date}`}
                  icon={<ErrorIcon />}
                />
               
               {!isExistOpenProblem && (
                <StatusBadgeWrapper>
                  <StatusBadge statusColor={getStatusColor(Status)}>
                    {
                      Status === 0 || Status === 3 ? 'פתוח' :
                      "סגור"
                    }
                  </StatusBadge>
                </StatusBadgeWrapper>
               )}
              </TitleRow>
              <TitleRow>
                <TitleRowItem 
                  name={formattedDeliveryDate}
                  icon={<CalendatDay />}
                />
                <TitleRowItem 
                  name={Delivery_Num + (Delivery_Sub ? `-${Delivery_Sub}` : '')}
                  icon={<InvoiceIcon />}
                />
              </TitleRow>
              <TitleRow>
               {
                Meher !== 0 && (
                  <BadgeWrapper>
                    לקוח מכר
                  </BadgeWrapper>
                )
               }
                <TitleRowItem 
                  name={`${Customer_Name}`}
                  icon={<UserIcon />}
                />
                {
                  Seller_Desc.trim() && (
                    <TitleRowItem 
                      name={Seller_Desc}
                      icon={<DollarIcon />}
                    />
                  )
                }
              </TitleRow>
              <TitleRow>
                <TitleRowItem 
                  name={FullDescription}
                  icon={<AppleIcon />}
                />
              </TitleRow>
              {Remark && (
                <TitleRow>
                  <TitleRowItem 
                    name={`הערה: ${Remark}`}
                    icon={<EditIcon />}
                  />
                </TitleRow>
              )}
              {(hasProblems || displayStatusText === 'ללא פניות') && (
              <TitleRow>
                <ProblemStatusWrapper>
                  {hasProblems && statusCounts.waiting > 0 && (
                    <ProblemCount $statusColor={getStatusColor(0)}>
                      {problemStatuses[0]}: {statusCounts.waiting}
                    </ProblemCount>
                  )}
                  {hasProblems && statusCounts.rejected > 0 && (
                    <ProblemCount $statusColor={getStatusColor(2)}>
                      {problemStatuses[2]}: {statusCounts.rejected}
                    </ProblemCount>
                  )}
                  {hasProblems && statusCounts.approved > 0 && (
                    <ProblemCount $statusColor={getStatusColor(1)}>
                      {problemStatuses[1]}: {statusCounts.approved}
                    </ProblemCount>
                  )}
                  {hasProblems && statusCounts.panding > 0 && (
                    <ProblemCount $statusColor={getStatusColor(3)}>
                      {problemStatuses[3]}: {statusCounts.panding}
                    </ProblemCount>
                  )}
                  {
                    <ProblemBadge $statusColor={displayColor}>
                      {displayStatusText === 'ללא פניות' ? 
                      'ללא פניות' : ''} 
                      {hasProblems && `(${statusCounts.total})`}
                    </ProblemBadge>

                  }
                  {HasPhotoOrComment && handleOpenProblemImages && (
                    <KbdChipButton
                      variant='accent'
                      aria-label='תמונות / הערות'
                      title='תמונות / הערות'
                      onClick={handleImagesClick}
                    >
                      <PaperclipIcon size={18} />
                    </KbdChipButton>
                  )}
                </ProblemStatusWrapper>
              </TitleRow>
            )}
              {
              isAllowToApprove && isExistOpenProblem && isOfficeUser && (
                <ProfitBadgeWrapper>
                  <DeliveryProfitBadge 
                    currentProfit={DeliveryProfit}
                    potentialLoss={DeliveryProfitDelta}
                    profitInPercentage={DeliveryProfitPercentage}
                  />
                </ProfitBadgeWrapper>
              )}
            </TitleWrapper>
            {
              isShowDelete &&
              <DeleteWrapper
                onClick={handleDeleteItem}
              >
                <DeleteIcon />
              </DeleteWrapper>
            }
            
          </MainContentWrapper>
        </SwipeableListItem>
      </TitleLayout>
      
      {isOpen && (
        <DetailsWrapper>
          {ProblemLines.map((detail) => (
            <ProblemDetailsItem
              key={detail.RecID}
              isOfficeUser={isOfficeUser}
              {...detail}
              handleApproveProblem={handleClickApproveProblem}
              handleOpenDriverStatusModal={openDriverStatusForLine}
            />
          ))}
        </DetailsWrapper>
      )}
    </MainWrapper>
  )
}

const MainContentWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
  align-items: center;
`
const IconElement = styled.div`
  cursor: pointer;
  border-radius: 50%;
  color: #297F76;
`
const BadgeWrapper = styled.div`
  border-radius: 10px;
  background-color: tomato;
  color: #fff;
  padding: 0.2em 0.4em;
`
const TitleWrapper = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-flow: column;
  min-height: 4em;
  gap: 0.1em;
`

const SideWrapper = styled.div`
  position: absolute;
  top: calc(50% - 1.6em);
  left: 1em;
  width: 3.5em;
  height: 3.5em;
`

const DetailsWrapper = styled.div`
  display: flex;
  flex-flow: column;
  gap: 0.5em;
  width: 100%;
  padding: 0.5em;
`

const MainWrapper = styled.div<{$isOpen?: boolean}>`
  width: 100%;
  display: flex;
  flex-flow: column;
  border-radius: 25px;
  background-color: #E9F0F0;
  border: ${props => props.$isOpen ? '3px solid #000' : 'none'};
`

const EditButtonWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 0.5em;
  transform: translateY(-50%);
  z-index: 10;
`

const DeleteWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4em;
  height: 100%;
  background-color: tomato;
  border-radius: 0;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0;
  flex-shrink: 0;
  
  &:hover {
    background-color: #ff4444;
    transform: scale(1.05);
  }
`
const TimeWrapper = styled.div`
  position: absolute;
  top: 0.2em;
  left: 0.2em;
  display: flex;
  gap: 0.5em; 
`
const StatusBadgeWrapper = styled.div`
  position: absolute;
  bottom: 0.2em;
  left: 0.2em;
`
const ProblemStatusWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  align-items: center;
  margin-top: 0.25em;
`

const ProblemBadge = styled.div<{ $statusColor: string }>`
  background: ${props => props.$statusColor};
  color: white;
  padding: 0.25em 0.5em;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
`

const ProblemCount = styled.div<{ $statusColor: string }>`
  background: ${props => props.$statusColor}20;
  color: ${props => props.$statusColor};
  border: 1px solid ${props => props.$statusColor};
  padding: 0.2em 0.4em;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 500;
`
const SelectorWrapper = styled.div`
  position: absolute;
  bottom: 1em;
  left: 1.2em;
  z-index: 4;
`

const ProfitBadgeWrapper = styled.div`
  width: 100%;
  margin-top: 0.5em;
`

export default ProblemWithDetailsItem 